import React from 'react';
import {
    CustomSelectDropdownWrapper,
    Label,
    Option,
    SubLabel,
} from '@routes/sidebar/admin-center/tenant-client/___pages___/matrices/ui/___shared___/components/custom-select-dropdown/styled.tsx';
import type { FormInstance, SelectProps } from 'antd';

type PopupRender = NonNullable<SelectProps['popupRender']>;
type MenuElement = Parameters<PopupRender>[0];

interface OptionItem {
    value: string;
    label: string | React.ReactNode;
    subLabel?: string | React.ReactNode;
}

interface Props {
    menu: MenuElement;
    options?: OptionItem[];
    isRegularDropdown?: boolean;
    form?: FormInstance;
    fieldName?: string;
    onSelect?: () => void; // call setIsOpen to close menu after selection
}

/*

--- ADD STYLES in App.css for option, selected option and active option ---
(already added for the admin-center-custom-select-dropdown-matrices class)

--- JUST LABEL ---
<BaseSelect popupRender={(menu) => <CustomSelectDropdownMatrices menu={menu} />} options={OPTIONS} />

--- WITH SUB LABEL ---
A. Easiest. Don't use popupRender but format options with styled elements e.g.

const OPTIONS = [{ value: 'val1', label: 'value 1', subLabel: 'some sub label 1' },
{ value: 'val2', label: 'value 2', subLabel: 'some sub label 2' },]
.map((o) => ({
    value: o.value,
    label: (
        <div>
            <Label>{o.label}</Label>
            {o.subLabel && <SubLabel>{o.subLabel}</SubLabel>}
        </div>
        ),
    }))
    
 <BaseSelect options={OPTIONS} popupClassName={'admin-center-custom-select-dropdown-matrices'} />
 
This will also show subLabel when option chosen, to show value when option selected then use <BaseSelect optionLabelProp="value" />

B. Controlled. Form, field name and close logic needs to be provided because we're overriding antd's behavior. 

1. const [isOpen, setIsOpen] = useState(false);
2. 
<BaseSelect
    onDropdownVisibleChange={setIsOpen}
    open={isOpen}
    popupRender={(menu) => (
        <CustomSelectDropdownMatrices
            menu={menu}
            form={form}
            fieldName={YOUR_FIELD_NAME}
            options={OPTIONS} // OptionItem[]
            isRegularDropdown={false}
            onSelect={() => setIsOpen(false)}
        />
    )}
    options={OPTIONS} // OptionItem[]
/>

*/

export const CustomSelectDropdownMatrices: React.FC<Props> = ({
    menu,
    options = [],
    form,
    fieldName,
    onSelect,
    isRegularDropdown = true,
}) => {
    if (isRegularDropdown) {
        return <div className="admin-center-custom-select-dropdown-matrices">{menu}</div>;
    }

    return (
        <CustomSelectDropdownWrapper>
            {options.map((option) => (
                <Option
                    key={option.value}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => {
                        form?.setFieldsValue({ [fieldName!]: option.value });
                        onSelect?.();
                    }}
                >
                    <Label>{option.label}</Label>
                    {!!option.subLabel && <SubLabel>{option.subLabel}</SubLabel>}
                </Option>
            ))}
        </CustomSelectDropdownWrapper>
    );
};
